import * as actions from './migrationModalActions';

export const initialState = { 
  open: false,
  migrationData: null,
  migrationMessage: '',
  blockedDocuments: null,
  linkedDocuments: null, // Keep for backward compatibility with old API responses
};

export default function migrationModalReducer(state = initialState, action = {}) {
  switch (action.type) {
    case actions.OPEN:
      return {
        ...state,
        open: true,
        migrationData: action.migrationData,
        migrationMessage: action.migrationMessage || '',
        blockedDocuments: action.blockedDocuments || null,
        linkedDocuments: action.linkedDocuments || null,
      };
    case actions.CLOSE:
      return {
        ...state,
        open: false,
        migrationData: null,
        migrationMessage: '',
        blockedDocuments: null,
        linkedDocuments: null,
      };
    default:
      return state;
  }
}
